
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "whats-new-in-apache-atlas-23"
    }}>{`What's new in Apache Atlas 2.3?`}</h1>
    <h2 {...{
      "id": "features"
    }}>{`Features`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`(new) Relationship search`}</strong>{`: API and UI to search relationships based on type and properties`}</li>
    </ul>
    <h2 {...{
      "id": "enhancements"
    }}>{`Enhancements`}</h2>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Resiliency`}</strong>{`: improvements in handling of index update failures`}</li>
      <li parentName="ul"><strong parentName="li">{`Glossary`}</strong>{`: performance improvements in dealing with large glossaries and bulk creation of glossary terms`}</li>
      <li parentName="ul"><strong parentName="li">{`Observability`}</strong>{`: UI improvements to view metrics & stats, persistence of metrics to enable historic data`}</li>
      <li parentName="ul"><strong parentName="li">{`Lineage`}</strong>{`: performance improvements in lineage API and UI`}</li>
      <li parentName="ul"><strong parentName="li">{`Notification`}</strong>{`: updated notifications to include hook version and message source`}</li>
      <li parentName="ul"><strong parentName="li">{`Hive integration`}</strong>{`: multiple fixes and improvements in Hive hook and import-hive utility`}</li>
      <li parentName="ul"><strong parentName="li">{`Impala integration`}</strong>{`: performance improvements`}</li>
      <li parentName="ul"><strong parentName="li">{`Audits`}</strong>{`: support for authentication enabled Cassandra as audit store`}</li>
      <li parentName="ul"><strong parentName="li">{`Python`}</strong>{`: released Apache Atlas Python client 0.0.12`}</li>
      <li parentName="ul"><strong parentName="li">{`Dependencies Upgrade`}</strong>{`: JanusGraph, Elasticsearch, Kafka, Storm, TinkerPop, Gson, Spring Framework, Log4j`}</li>
      <li parentName="ul"><strong parentName="li">{`UI`}</strong>{`: fixes and improvements in multiple areas like search, lineage, business metadata`}</li>
      <li parentName="ul"><strong parentName="li">{`Docker image`}</strong>{`: improvements to Docker support`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://issues.apache.org/jira/issues/?jql=project%20%3D%20ATLAS%20AND%20status%20%3D%20Resolved%20AND%20fixVersion%20%3D%202.3.0%20ORDER%20BY%20key%20DESC"
        }}>{`List of JIRAs resolved in Apache Atlas 2.3.0 release`}</a></li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;